export const MICROSOFT_AGREEMENT_URL = 'https://aka.ms/customeragreement';
export const CONTACT_SUPPORT_URL = 'https://support.microsoft.com';
